import LTR from "@brand-icons/ploom/chat/chat-ltr.svg";
import RTL from "@brand-icons/ploom/chat/chat-rtl.svg";

import { iconFactory } from "../iconFactory";

export const ChatIcon = iconFactory("ChatIcon", LTR, RTL);
